module.exports = __webpack_public_path__ + "static/media/flipHorizontal.40ea72f7.svg";